import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

export const Anchor = ({
  children,
  color = 'primary',
  className = '',
  leftIcon,
  disabled,
  rightIcon,
  ...props
}) => {
  let style = null

  if (disabled) {
    style = { pointerEvents: 'none', opacity: 0.65 }
  }

  return (
    <Link
      className={classNames('', {
        [`text-${color}`]: color,
        [className]: className,
      })}
      style={style}
      {...props}
    >
      {leftIcon && <span className={'me-2'}>{leftIcon}</span>}

      {children}

      {rightIcon && <span className={'ms-2'}>{rightIcon}</span>}
    </Link>
  )
}

Anchor.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  className: PropTypes.string,
  leftIcon: PropTypes.any,
  disabled: PropTypes.bool,
  rightIcon: PropTypes.any,
}
